import html from "../components/ContentHtml/config";
import fundamentals from "../components/Content/config";

export const getCoursePackageData = (slug) => {
  switch (slug) {
    case "html":
      return html.levelContentData;
    case "fundamentals":
      return fundamentals.levelContentData;
    default:
      return [];
  }
};
